if (!customElements.get('myrevora-final-purchase-v2')) {
  customElements.define('myrevora-final-purchase-v2', class extends HTMLElement {
    connectedCallback() {
      this.main = Array.from(document.querySelectorAll('product-info')).find(
        (element) => element.dataset.productId === this.dataset.productId && element.dataset.updateUrl !== 'false'
      );
      if (!this.main) return;
      this.sync = this.sync.bind(this);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.main, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['disabled', 'value', 'class']
      });
      this.main.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.main?.removeEventListener('change', this.sync);
    }
    sync() {
      const source = this.main.querySelector('product-form');
      const sourceButton = source?.querySelector('[type="submit"]');
      const sourceId = source?.querySelector('[name="id"]');
      const button = this.querySelector('[type="submit"]');
      const input = this.querySelector('[name="id"]');
      if (!sourceButton || !sourceId || !button || !input) return;
      input.value = sourceId.value;
      const disabled = sourceButton.disabled || !sourceId.value;
      button.disabled = disabled;
      const label = button.querySelector('span');
      if (label) label.textContent = disabled ? sourceButton.querySelector('span').textContent : this.dataset.cta;
      const price = this.main.querySelector('[id^="price-"]');
      const destination = this.querySelector('[data-final-price]');
      if (price && destination) {
        if (destination.innerHTML !== price.innerHTML) destination.innerHTML = price.innerHTML;
        destination.hidden = price.classList.contains('hidden');
      }
      const minimum = this.main.querySelector('input[name="quantity"]')?.min;
      if (minimum) this.querySelector('[name="quantity"]').value = minimum;
    }
  });
}
